export default __webpack_public_path__ + "static/media/generate-suggestion.b6fad1c3.svg";